import { render, staticRenderFns } from "./GradientColorPicker.vue?vue&type=template&id=55f48ce4&scoped=true"
import script from "./GradientColorPicker.vue?vue&type=script&lang=js"
export * from "./GradientColorPicker.vue?vue&type=script&lang=js"
import style0 from "./GradientColorPicker.vue?vue&type=style&index=0&id=55f48ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f48ce4",
  null
  
)

export default component.exports